import React from 'react';
import styles from './Features.module.css';

function Features({ features }) {
    return (
        <section className={styles.features}>
            {features.map((feature, index) => (
                <div className={styles.featureCard} key={index}>
                    <img src={feature.img} alt={feature.alt} />
                    <h3>{feature.title}</h3>
                    <p>{feature.description}</p>
                </div>
            ))}
        </section>
    );
}

export default Features;